import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import {
    UploadResponse,
    UploadResponseSchema,
} from "../response/RateImportResponse";

const API_VERSION = "v4";

export interface UploadRatesPayload {
    propertyId: string;
    file: File;
}

/**
 * Custom hook untuk mengunggah file Import Rates (multipart) dan mendapatkan preview.
 */
export const useUploadRates = () => {
    return useMutation<UploadResponse, unknown, UploadRatesPayload>({
        mutationFn: async ({ propertyId, file }) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("property_id", propertyId);

            const response = await privateApi.post(
                `/${API_VERSION}/rate-import/upload`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return UploadResponseSchema.parse(response.data);
        },
    });
};
